import React, { useEffect, useState } from "react";
import { Text } from "@100mslive/roomkit-react";
import { ErrorDialog } from "../../primitives/DialogContent";

export const InitErrorModal = ({ notification }) => {
  const [showModal, setShowModal] = useState(false);
  const [info, setInfo] = useState({
    title: "Init Error",
    description: "",
    check: false,
  });

  useEffect(() => {
    const data = notification?.data;
    if (!data || data.action !== "INIT") {
      return;
    }
    let description;
    let title;
    let check = false;
    if (data.description.includes("role is invalid")) {
      description =
        "This role does not exist for the given room. Try again with a valid role.";
      title = "Invalid Role";
    } else if (data.description.includes("room is not active")) {
      title = "Questions Answered";
      description =
        "You have already answered all questions, please continue with your process.";
      check = true;
    } else {
      description = data.description;
      title = "Init Error";
    }
    setInfo({ title, description, check });
    setShowModal(true);
  }, [notification]);

  return (
    <ErrorDialog
      open={showModal}
      onOpenChange={setShowModal}
      title={info.title}
      check={info.check}
    >
      <Text variant="sm" css={{ wordBreak: "break-word" }}>
        {info.description} <br />
        {info.check == false && `Current URL - ${window.location.href}`}
      </Text>
    </ErrorDialog>
  );
};
